export type {
  AddUpsellToBagParams as AddUpsellToBagParamsLegacy,
  ApplyGiftCardParams as ApplyGiftCardParamsLegacy,
  ApplyPromoCodeParams as ApplyPromoCodeParamsLegacy,
  ApplyRewardParams as ApplyRewardParamsLegacy,
  ChangeLineItemQuantityParams as ChangeLineItemQuantityParamsLegacy,
  RemoveRewardParams as RemoveRewardParamsLegacy,
} from './ordering-machine.types';
export * from './useOrderingMachineLegacy';
